import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useAddOrganizationMutation } from '../../services/portal';

const CreateOrganization = () => {
  let navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const [buttonSubmitDisabled, setButtonSubmitDisabled] = useState(false);
  const [showAdditionalInfo, setShowAdditionalInfo] = useState(false);

  const [addOrganization, { isLoading: isUpdating }] =
    useAddOrganizationMutation();

  const handleCancel = () => {
    navigate('/organizations');
  };

  /*const onSubmit = (formData) => {
    setButtonSubmitDisabled(true);
    addOrganization({
      organization_name: formData.organizationName,
      contact_persons: [
        {
          name: formData.primaryName,
          email: formData.primaryEmail,
          phone: formData.primaryTelNumber
        },
        {
          name: formData.secondaryName ? formData.secondaryName : ' ',
          email: formData.secondaryEmail ? formData.secondaryEmail : ' ',
          phone: formData.secondaryTelNumber ? formData.secondaryTelNumber : ' '
        }
      ],
      comments: formData.organizationDescription
    })
      .unwrap()
      .then((payload) => {
        navigate('/organizations');
      })
      .catch((error) => console.error('rejected', error));
  };*/
  const onSubmit = (formData) => {
    setButtonSubmitDisabled(true);

    // Prepare the payload with all fields
    const payload = {
      organization_name: formData.organizationName,
      contact_persons: [
        {
          name: formData.primaryName,
          email: formData.primaryEmail,
          phone: formData.primaryTelNumber
        },
        {
          name: formData.secondaryName ? formData.secondaryName : ' ',
          email: formData.secondaryEmail ? formData.secondaryEmail : ' ',
          phone: formData.secondaryTelNumber ? formData.secondaryTelNumber : ' '
        }
      ],
      comments: formData.organizationDescription
    };

    // Add additional info fields if checkbox is checked
    if (showAdditionalInfo) {
      // Bit fields default to 0 instead of null
      payload.configurePortalAndTenant = formData.configurePortalAndTenant ? 1 : 0;
      payload.clientWhiteLabeledPortal = formData.clientWhiteLabeledPortal ? 1 : 0;
      payload.clientOwnCapacity = formData.clientOwnCapacity ? 1 : 0;
      payload.configureBilling = formData.configureBilling ? 1 : 0;
      payload.ownCapacity = formData.ownCapacity ? 1 : 0;
      payload.supportOption = formData.supportOption ? 1 : 0;

      // String fields can be null
      payload.applicationID = formData.applicationID || null;
      payload.theme = formData.theme || null;
      payload.logoText = formData.logoText || null;
      payload.loginPageType = formData.loginPageType || null;
      payload.powerBIClientID = formData.powerBIClientID || null;
      payload.powerBIClientSecret = formData.powerBIClientSecret || null;
      payload.powerBITenant = formData.powerBITenant || null;
      payload.startStopClientID = formData.startStopClientID || null;
      payload.startStopTenant = formData.startStopTenant || null;
      payload.startStopClientSecret = formData.startStopClientSecret || null;
      payload.subscriptionID = formData.subscriptionID || null;
      payload.resourceGroupName = formData.resourceGroupName || null;
      payload.dedicatedCapacityName = formData.dedicatedCapacityName || null;
      payload.apiVersion = formData.apiVersion || null;
      payload.capacityStatus = formData.capacityStatus || null;
      payload.organizationOwner = formData.organizationOwner || null;

      // Numeric fields can be null
      payload.embeddedCapacityTimeout = formData.embeddedCapacityTimeout || null;
      payload.connectionType = formData.connectionType || null;
      payload.ownCapacityCost = formData.ownCapacityCost || null;
      payload.userCost = formData.userCost || null;
      payload.reportCost = formData.reportCost || null;
      payload.whiteLabelCost = formData.whiteLabelCost || null;
      payload.supportCost = formData.supportCost || null;

      // Date fields can be null
      payload.lastActiveDate = formData.lastActiveDate || null;
      payload.suspendDate = formData.suspendDate || null;
    }
console.log('Submitting organization:', payload);
    addOrganization(payload)
      .unwrap()
      .then((payload) => {
        navigate('/organizations');
      })
      .catch((error) => console.error('rejected', error));
  };

  return (
    <div className="page">
      <div className="page-inner">
        <header className="page-title-bar">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item active">
                <a href="/organizations">
                  <i className="breadcrumb-icon fa fa-angle-left mr-2"></i>
                  Organizations
                </a>
              </li>
            </ol>
          </nav>
          <div className="d-flex justify-content-between">
            <h1 className="page-title"> New Organization </h1>
          </div>
        </header>
        <div className="page-section">
          <div id="labels" className="card">
            <div className="card-body">
              <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
                <h6>Organization </h6>
                <div className="form-group col-md-6 mb-3">
                  <label htmlFor="organizationName">Name <span className="text-danger">*</span></label>
                  <div className="input-group">
                    <label
                      className="input-group-prepend"
                      htmlFor="organizationName">
                      <span className="input-group-text">
                        <span className="far fa-building"></span>
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="organizationName"
                      placeholder="Organization name"
                      {...register('organizationName', {
                        required: true,
                        minLength: 3
                      })}
                    />
                  </div>
                  {errors?.organizationName &&
                    errors.organizationName.type === 'required' && (
                      <p className="validate-feedback-invalid">
                        Organization name is required.
                      </p>
                    )}
                  {errors?.organizationName &&
                    errors.organizationName.type === 'minLength' && (
                      <p className="validate-feedback-invalid">
                        Organization name must have at least 3 characters.
                      </p>
                    )}
                </div>
                <div className="form-group col-md-6 mb-3">
                  <label htmlFor="organizationDescription">Description</label>
                  <textarea
                    className="form-control"
                    id="organizationDescription"
                    rows="3"
                    placeholder="Organization description"
                    {...register('organizationDescription')}
                  />
                </div>
                <h6>Primary contact</h6>
                <div className="form-group col-md-6 mb-3">
                  <div className="input-group input-group-alt">
                    <label
                      className="input-group-prepend"
                      htmlFor="primaryName">
                      <span
                        className="input-group-text"
                        style={{ minWidth: 90 }}>
                        Full name: <span className="text-danger">*</span>
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="primaryName"
                      placeholder="Full name"
                      {...register('primaryName', { required: true })}
                    />
                  </div>
                  {errors.primaryName &&
                    errors.primaryName.type === 'required' && (
                      <p className="validate-feedback-invalid">
                        Primary contact name is required.
                      </p>
                    )}
                </div>
                <div className="form-group col-md-6 mb-3">
                  <div className="input-group input-group-alt">
                    <label
                      className="input-group-prepend"
                      htmlFor="primaryEmail">
                      <span
                        className="input-group-text"
                        style={{ minWidth: 90 }}>
                        Email: <span className="text-danger">*</span>
                      </span>
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="primaryEmail"
                      placeholder="Email address"
                      {...register('primaryEmail', {
                        required: true,
                        pattern:
                          /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i
                      })}
                    />
                  </div>
                  {errors.primaryEmail && (
                    <p className="validate-feedback-invalid">
                      Valid primary contact email is required.
                    </p>
                  )}
                </div>
                <div className="form-group col-md-6 mb-3">
                  <div className="input-group input-group-alt">
                    <label
                      className="input-group-prepend"
                      htmlFor="primaryTelNumber">
                      <span
                        className="input-group-text"
                        style={{ minWidth: 90 }}>
                        Phone: <span className="text-danger">*</span>
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="primaryTelNumber"
                      placeholder="Phone number"
                      {...register('primaryTelNumber', { required: true })}
                    />
                  </div>
                  {errors.primaryTelNumber &&
                    errors.primaryTelNumber.type === 'required' && (
                      <p className="validate-feedback-invalid">
                        Primary contact phone number is required.
                      </p>
                    )}
                </div>
                <h6>Secondary contact</h6>
                <div className="form-group col-md-6 mb-3">
                  <div className="input-group input-group-alt">
                    <label
                      className="input-group-prepend"
                      htmlFor="secondaryName">
                      <span
                        className="input-group-text"
                        style={{ minWidth: 90 }}>
                        Full name:
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="secondaryName"
                      placeholder="Full name"
                      {...register('secondaryName')}
                    />
                  </div>
                </div>
                <div className="form-group col-md-6 mb-3">
                  <div className="input-group input-group-alt">
                    <label
                      className="input-group-prepend"
                      htmlFor="secondaryEmail">
                      <span
                        className="input-group-text"
                        style={{ minWidth: 90 }}>
                        Email:
                      </span>
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="secondaryEmail"
                      placeholder="Email address"
                      {...register('secondaryEmail')}
                    />
                  </div>
                </div>
                <div className="form-group col-md-6 mb-3">
                  <div className="input-group input-group-alt">
                    <label
                      className="input-group-prepend"
                      htmlFor="secondaryTelNumber">
                      <span
                        className="input-group-text"
                        style={{ minWidth: 90 }}>
                        Phone:
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="secondaryTelNumber"
                      placeholder="Phone number"
                      {...register('secondaryTelNumber')}
                    />
                  </div>
                </div>

                {/* Add Additional Info Checkbox */}
                <div className="form-group col-md-6 mb-3">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="addAdditionalInfo"
                      checked={showAdditionalInfo}
                      onChange={(e) => setShowAdditionalInfo(e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="addAdditionalInfo">
                      Add Additional Info
                    </label>
                  </div>
                </div>

                {/* Additional Info Section - Only show when checkbox is checked */}
                {showAdditionalInfo && (
                  <div className="additional-info-section">
                    <hr className="mb-3 mt-3" />

                    {/* Portal and Client Capacity Settings */}
                    <h6>Portal and Client Capacity Settings</h6>
                    <div className="row">
                      <div className="form-group col-md-6 mb-3">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="configurePortalAndTenant"
                            {...register('configurePortalAndTenant')}
                          />
                          <label className="form-check-label" htmlFor="configurePortalAndTenant">
                            Configure Portal and Tenant
                          </label>
                        </div>
                      </div>
                    </div>

                    {/* White Label Portal Options */}
                    <h6>White Label Portal Options</h6>
                    <div className="row">
                      <div className="form-group col-md-6 mb-3">
                        <label htmlFor="applicationID">Application ID</label>
                        <input
                          type="text"
                          className="form-control"
                          id="applicationID"
                          placeholder="e.g., prod.biportal.co.za"
                          {...register('applicationID')}
                        />
                      </div>
                      <div className="form-group col-md-6 mb-3">
                        <label htmlFor="theme">Theme</label>
                        <input
                          type="text"
                          className="form-control"
                          id="theme"
                          placeholder="Default: cool_blue"
                          {...register('theme')}
                        />
                      </div>
                      <div className="form-group col-md-6 mb-3">
                        <label htmlFor="logoText">Logo Text</label>
                        <input
                          type="text"
                          className="form-control"
                          id="logoText"
                          placeholder="Logo text"
                          {...register('logoText')}
                        />
                      </div>
                      <div className="form-group col-md-6 mb-3">
                        <label htmlFor="loginPageType">Login Page Type</label>
                        <input
                          type="text"
                          className="form-control"
                          id="loginPageType"
                          placeholder="Default: cover"
                          {...register('loginPageType')}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-md-6 mb-3">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="clientWhiteLabeledPortal"
                            {...register('clientWhiteLabeledPortal')}
                          />
                          <label className="form-check-label" htmlFor="clientWhiteLabeledPortal">
                            Client White Labeled Portal
                          </label>
                        </div>
                      </div>
                    </div>

                    {/* Client Tenant Settings */}
                    <h6>Client Tenant Settings</h6>
                    <div className="row">
                      <div className="form-group col-md-6 mb-3">
                        <label htmlFor="powerBIClientID">Power BI Client ID</label>
                        <input
                          type="text"
                          className="form-control"
                          id="powerBIClientID"
                          placeholder="Power BI Client ID"
                          {...register('powerBIClientID')}
                        />
                      </div>
                      <div className="form-group col-md-6 mb-3">
                        <label htmlFor="powerBIClientSecret">Power BI Client Secret</label>
                        <input
                          type="password"
                          className="form-control"
                          id="powerBIClientSecret"
                          placeholder="Power BI Client Secret"
                          {...register('powerBIClientSecret')}
                        />
                      </div>
                      <div className="form-group col-md-6 mb-3">
                        <label htmlFor="powerBITenant">Power BI Tenant</label>
                        <input
                          type="text"
                          className="form-control"
                          id="powerBITenant"
                          placeholder="Power BI Tenant"
                          {...register('powerBITenant')}
                        />
                      </div>
                      <div className="form-group col-md-6 mb-3">
                        <label htmlFor="startStopClientID">Start/Stop Client ID</label>
                        <input
                          type="text"
                          className="form-control"
                          id="startStopClientID"
                          placeholder="Start/Stop Client ID"
                          {...register('startStopClientID')}
                        />
                      </div>
                      <div className="form-group col-md-6 mb-3">
                        <label htmlFor="startStopTenant">Start/Stop Tenant</label>
                        <input
                          type="text"
                          className="form-control"
                          id="startStopTenant"
                          placeholder="Start/Stop Tenant"
                          {...register('startStopTenant')}
                        />
                      </div>
                      <div className="form-group col-md-6 mb-3">
                        <label htmlFor="startStopClientSecret">Start/Stop Client Secret</label>
                        <input
                          type="password"
                          className="form-control"
                          id="startStopClientSecret"
                          placeholder="Start/Stop Client Secret"
                          {...register('startStopClientSecret')}
                        />
                      </div>
                      <div className="form-group col-md-6 mb-3">
                        <label htmlFor="embeddedCapacityTimeout">Embedded Capacity Timeout</label>
                        <input
                          type="number"
                          className="form-control"
                          id="embeddedCapacityTimeout"
                          placeholder="Timeout in minutes"
                          {...register('embeddedCapacityTimeout')}
                        />
                      </div>
                      <div className="form-group col-md-6 mb-3">
                        <label htmlFor="subscriptionID">Subscription ID</label>
                        <input
                          type="text"
                          className="form-control"
                          id="subscriptionID"
                          placeholder="Azure Subscription ID"
                          {...register('subscriptionID')}
                        />
                      </div>
                      <div className="form-group col-md-6 mb-3">
                        <label htmlFor="resourceGroupName">Resource Group Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="resourceGroupName"
                          placeholder="Resource Group Name"
                          {...register('resourceGroupName')}
                        />
                      </div>
                      <div className="form-group col-md-6 mb-3">
                        <label htmlFor="dedicatedCapacityName">Dedicated Capacity Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="dedicatedCapacityName"
                          placeholder="Dedicated Capacity Name"
                          {...register('dedicatedCapacityName')}
                        />
                      </div>
                      <div className="form-group col-md-6 mb-3">
                        <label htmlFor="apiVersion">API Version</label>
                        <input
                          type="text"
                          className="form-control"
                          id="apiVersion"
                          placeholder="API Version"
                          {...register('apiVersion')}
                        />
                      </div>
                      <div className="form-group col-md-6 mb-3">
                        <label htmlFor="connectionType">Connection Type</label>
                        <select
                          className="form-control"
                          id="connectionType"
                          {...register('connectionType')}
                        >
                          <option value="">Select Connection Type</option>
                          <option value="1">Power BI Embedded</option>
                          <option value="2">Fabric</option>
                        </select>
                      </div>
                      <div className="form-group col-md-6 mb-3">
                        <label htmlFor="capacityStatus">Capacity Status</label>
                        <input
                          type="text"
                          className="form-control"
                          id="capacityStatus"
                          placeholder="Capacity Status"
                          {...register('capacityStatus')}
                        />
                      </div>
                      <div className="form-group col-md-6 mb-3">
                        <label htmlFor="lastActiveDate">Last Active Date</label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          id="lastActiveDate"
                          {...register('lastActiveDate')}
                        />
                      </div>
                      <div className="form-group col-md-6 mb-3">
                        <label htmlFor="suspendDate">Suspend Date</label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          id="suspendDate"
                          {...register('suspendDate')}
                        />
                      </div>
                      <div className="form-group col-md-6 mb-3">
                        <label htmlFor="organizationOwner">Organization Owner</label>
                        <input
                          type="text"
                          className="form-control"
                          id="organizationOwner"
                          placeholder="Organization Owner"
                          {...register('organizationOwner')}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-md-6 mb-3">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="clientOwnCapacity"
                            {...register('clientOwnCapacity')}
                          />
                          <label className="form-check-label" htmlFor="clientOwnCapacity">
                            Client Own Capacity
                          </label>
                        </div>
                      </div>
                    </div>

                    {/* Billing Settings */}
                    <h6>Billing Settings</h6>
                    <div className="row">
                      <div className="form-group col-md-6 mb-3">
                        <label htmlFor="ownCapacityCost">Own Capacity Cost</label>
                        <input
                          type="number"
                          step="0.01"
                          className="form-control"
                          id="ownCapacityCost"
                          placeholder="0.00"
                          {...register('ownCapacityCost')}
                        />
                      </div>
                      <div className="form-group col-md-6 mb-3">
                        <label htmlFor="userCost">User Cost</label>
                        <input
                          type="number"
                          step="0.01"
                          className="form-control"
                          id="userCost"
                          placeholder="0.00"
                          {...register('userCost')}
                        />
                      </div>
                      <div className="form-group col-md-6 mb-3">
                        <label htmlFor="reportCost">Report Cost</label>
                        <input
                          type="number"
                          step="0.01"
                          className="form-control"
                          id="reportCost"
                          placeholder="0.00"
                          {...register('reportCost')}
                        />
                      </div>
                      <div className="form-group col-md-6 mb-3">
                        <label htmlFor="whiteLabelCost">White Label Cost</label>
                        <input
                          type="number"
                          step="0.01"
                          className="form-control"
                          id="whiteLabelCost"
                          placeholder="0.00"
                          {...register('whiteLabelCost')}
                        />
                      </div>
                      <div className="form-group col-md-6 mb-3">
                        <label htmlFor="supportCost">Support Cost</label>
                        <input
                          type="number"
                          step="0.01"
                          className="form-control"
                          id="supportCost"
                          placeholder="0.00"
                          {...register('supportCost')}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-md-6 mb-3">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="configureBilling"
                            {...register('configureBilling')}
                          />
                          <label className="form-check-label" htmlFor="configureBilling">
                            Configure Billing
                          </label>
                        </div>
                      </div>
                      <div className="form-group col-md-6 mb-3">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="ownCapacity"
                            {...register('ownCapacity')}
                          />
                          <label className="form-check-label" htmlFor="ownCapacity">
                            Own Capacity
                          </label>
                        </div>
                      </div>
                      <div className="form-group col-md-6 mb-3">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="supportOption"
                            {...register('supportOption')}
                          />
                          <label className="form-check-label" htmlFor="supportOption">
                            Support Option
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                )}


                <hr className="mb-0 mt-0"></hr>
                <div className="form-actions">
                  <button
                    className="btn btn-primary"
                    disabled={buttonSubmitDisabled}
                    type="submit">
                    Save
                  </button>
                  <button
                    className="btn btn-secondary"
                    style={{ marginLeft: 10 }}
                    type="button"
                    onClick={handleCancel}>
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateOrganization;
